function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2896 5.60269C15.5319 5.82558 15.5477 6.20271 15.3248 6.44504L11.4908 10.6134L15.6592 14.4474C15.9015 14.6703 15.9173 15.0474 15.6944 15.2898C15.4715 15.5321 15.0943 15.5478 14.852 15.325L10.6836 11.491L6.84966 15.6593C6.62677 15.9017 6.24963 15.9174 6.0073 15.6945C5.76498 15.4717 5.74922 15.0945 5.97211 14.8522L9.80609 10.6838L5.63771 6.84983C5.39538 6.62694 5.37962 6.24981 5.60251 6.00748C5.8254 5.76515 6.20254 5.74939 6.44487 5.97228L10.6132 9.80626L14.4472 5.63789C14.6701 5.39556 15.0473 5.3798 15.2896 5.60269Z",
  fill: "black"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.acaf2e7a.svg";
export { ForwardRef as ReactComponent };